import {
  RESET_SUPERADMIN_SEARCH_LOCATION,
  SUPERADMIN_SEARCH_LOCATION_ERROR,
  SUPERADMIN_SEARCH_LOCATION_LOADING,
  SUPERADMIN_SEARCH_LOCATION_SUCCESS,
} from "../type/Constant";

let initialState = {
  getLocationData: {
    loading: false,
    data: null,
    error: false,
    errors: null,
    success: false,
  },
};

export default function searchLocationReducer(state = initialState, action) {
  switch (action.type) {
    case SUPERADMIN_SEARCH_LOCATION_LOADING:
      return {
        ...state,
        getLocationData: {
          ...state.getLocationData,
          loading: true,
          error: false,
          errors: [],
          success: false,
        },
      };

    case SUPERADMIN_SEARCH_LOCATION_SUCCESS:
      return {
        ...state,
        getLocationData: {
          ...state.getLocationData,
          loading: false,
          error: false,
          errors: [],
          success: true,
          data: action.response.data,
        },
      };

    case SUPERADMIN_SEARCH_LOCATION_ERROR:
      return {
        ...state,
        getLocationData: {
          ...state.getLocationData,
          loading: false,
          error: true,
          errors: action.errors,
          success: false,
          data: null,
        },
      };

    case RESET_SUPERADMIN_SEARCH_LOCATION:
      return {
        ...state,
        getLocationData: {
          ...state.getLocationData,
          loading: false,
          error: false,
          errors: null,
          success: false,
        },
      };

    default:
      return state;
  }
}
